import { render, staticRenderFns } from "./homefire-document-info.vue?vue&type=template&id=5f09125f&scoped=true&"
import script from "./homefire-document-info.vue?vue&type=script&lang=js&"
export * from "./homefire-document-info.vue?vue&type=script&lang=js&"
import style0 from "./homefire-document-info.vue?vue&type=style&index=0&id=5f09125f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09125f",
  null
  
)

export default component.exports